module.exports = __webpack_public_path__ + "img/40_38_080_090.b59c944d.jpg";